(() => {
  const SELECTORS = [
    '.lg-product-row--carousel',
    '.lg-intent-grid--carousel',
    '.lg-recipes__category-grid--carousel'
  ];

  const createDragBar = (row) => {
    if (row.dataset.lgDragBarReady === 'true') return;
    row.dataset.lgDragBarReady = 'true';

    const wrapper = document.createElement('div');
    wrapper.className = 'lg-carousel-dragbar';

    const track = document.createElement('div');
    track.className = 'lg-carousel-dragbar__track';
    track.setAttribute('role', 'scrollbar');
    track.setAttribute('aria-label', 'Karussell horizontal verschieben');
    track.setAttribute('aria-orientation', 'horizontal');
    track.setAttribute('aria-valuemin', '0');
    track.setAttribute('aria-valuemax', '100');
    track.setAttribute('tabindex', '0');

    const thumb = document.createElement('div');
    thumb.className = 'lg-carousel-dragbar__thumb';
    thumb.setAttribute('aria-hidden', 'true');

    track.appendChild(thumb);
    wrapper.appendChild(track);
    row.insertAdjacentElement('afterend', wrapper);

    let dragging = false;
    let activePointerId = null;
    let pointerOffset = 0;
    let thumbWidth = 0;
    let maxThumbTravel = 0;

    const getMaxScroll = () => Math.max(0, row.scrollWidth - row.clientWidth);

    const syncFromRow = () => {
      const maxScroll = getMaxScroll();
      const progress = maxScroll > 0 ? row.scrollLeft / maxScroll : 0;
      const x = maxThumbTravel * progress;
      thumb.style.transform = `translate3d(${x}px, 0, 0)`;
      track.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
    };

    const measure = () => {
      const maxScroll = getMaxScroll();
      const visibleRatio = row.scrollWidth > 0 ? row.clientWidth / row.scrollWidth : 1;
      thumbWidth = Math.max(64, Math.min(track.clientWidth, track.clientWidth * visibleRatio));
      maxThumbTravel = Math.max(0, track.clientWidth - thumbWidth);
      thumb.style.width = `${thumbWidth}px`;
      wrapper.hidden = maxScroll <= 2;
      syncFromRow();
    };

    const setFromClientX = (clientX) => {
      const rect = track.getBoundingClientRect();
      const rawX = clientX - rect.left - pointerOffset;
      const x = Math.max(0, Math.min(maxThumbTravel, rawX));
      const progress = maxThumbTravel > 0 ? x / maxThumbTravel : 0;
      const nextScroll = getMaxScroll() * progress;

      row.scrollLeft = nextScroll;
      thumb.style.transform = `translate3d(${x}px, 0, 0)`;
      track.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
    };

    const startDrag = (event) => {
      if (event.button !== 0 || wrapper.hidden) return;

      measure();
      dragging = true;
      activePointerId = event.pointerId;

      const thumbRect = thumb.getBoundingClientRect();
      const startedOnThumb = event.target === thumb;
      pointerOffset = startedOnThumb
        ? event.clientX - thumbRect.left
        : thumbWidth / 2;

      track.setPointerCapture(event.pointerId);
      wrapper.classList.add('is-dragging');
      row.classList.add('lg-carousel-row--dragging');

      if (!startedOnThumb) setFromClientX(event.clientX);
      event.preventDefault();
    };

    const moveDrag = (event) => {
      if (!dragging || event.pointerId !== activePointerId) return;
      setFromClientX(event.clientX);
      event.preventDefault();
    };

    const endDrag = (event) => {
      if (!dragging || event.pointerId !== activePointerId) return;

      setFromClientX(event.clientX);
      dragging = false;
      activePointerId = null;

      if (track.hasPointerCapture(event.pointerId)) {
        track.releasePointerCapture(event.pointerId);
      }

      wrapper.classList.remove('is-dragging');
      row.classList.remove('lg-carousel-row--dragging');
      syncFromRow();
    };

    track.addEventListener('pointerdown', startDrag);
    track.addEventListener('pointermove', moveDrag);
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    track.addEventListener('keydown', (event) => {
      const maxScroll = getMaxScroll();
      if (maxScroll <= 0) return;

      const page = Math.max(80, row.clientWidth * 0.5);
      let next = row.scrollLeft;

      if (event.key === 'ArrowLeft') next -= page * 0.2;
      else if (event.key === 'ArrowRight') next += page * 0.2;
      else if (event.key === 'PageUp') next -= page;
      else if (event.key === 'PageDown') next += page;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = maxScroll;
      else return;

      event.preventDefault();
      row.scrollLeft = Math.max(0, Math.min(maxScroll, next));
    });

    row.addEventListener('scroll', () => {
      if (!dragging) syncFromRow();
    }, { passive: true });

    const resizeObserver = new ResizeObserver(measure);
    resizeObserver.observe(row);
    resizeObserver.observe(track);

    const mutationObserver = new MutationObserver(measure);
    mutationObserver.observe(row, { childList: true });

    requestAnimationFrame(measure);
  };

  const initialize = () => {
    SELECTORS.forEach((selector) => {
      document.querySelectorAll(selector).forEach(createDragBar);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(initialize), { once: true });
  } else {
    requestAnimationFrame(initialize);
  }

  document.addEventListener('shopify:section:load', () => requestAnimationFrame(initialize));

  const observer = new MutationObserver(() => requestAnimationFrame(initialize));
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
